"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "filterArgsForTasks", {
    enumerable: true,
    get: function() {
        return filterArgsForTasks;
    }
});
function filterArgsForTasks(args) {
    const optionsPosition = args.findIndex((arg)=>arg.startsWith("-"));
    return {
        tasks: args.slice(0, optionsPosition === -1 ? undefined : optionsPosition),
        taskArgs: optionsPosition === -1 ? [] : args.slice(optionsPosition)
    };
}
